import type { FC, HTMLProps } from 'react'
import { extractProps } from './extractProps'
import { InputLayout, type InputLayoutControlProps, type StripInputProps } from './InputLayout'
import { inputCssClass } from './inputCss'

export type NumberInputProps = StripInputProps<HTMLProps<HTMLInputElement>> &
  InputLayoutControlProps & { type: 'number'; ref?: React.Ref<HTMLInputElement> }

export const NumberInput: FC<StripInputProps<HTMLProps<HTMLInputElement>> & InputLayoutControlProps> = (props) => {
  const [layoutProps, inputProps] = extractProps(props)

  return (
    <InputLayout {...layoutProps}>
      <input type="number" className={inputCssClass} {...inputProps} />
    </InputLayout>
  )
}
